<template>
    <div class="userControlInfo spackage padding-20 bgc box-shadow">
        <div class="user_info_box">
            <div>
                <div>
                    <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                    <img :src="userInfo.customericonurl" alt="">
                    <span>{{userInfo.customername}}</span>
                </div>
            </div>
            <div>
                <div>
                    <label>姓名：</label>
                    <span>{{userInfo.customername}}</span>
                </div>
                <div>
                    <label>成交订单数：</label>
                    <span>{{userInfo.ordercount}}</span>
                </div>
                <div>
                    <label>邀请人数：</label>
                    <span>{{userInfo.invitecount}}</span>
                </div>
            </div>
            <div>
                <div>
                    <label>所在社群：</label>
                    <span>{{userInfo.assname}}</span>
                </div>
                <div>
                    <label>成交订单金额：</label>
                    <span>{{userInfo.ordermoney}}</span>
                </div>
                <div>
                    <label>加入时间：</label>
                    <span>{{userInfo.datetime}}</span>
                </div>
            </div>
        </div>
        <div class="tabs_box">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="订单列表" name="first">
                    <div class="order_list_box">
                        <OrderListTable :orderListData="orderListData"></OrderListTable>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="邀请用户" name="second">
                    <div class="invited_users_box">
                        <InvitedUsersTable :InvitedUsersListData="InvitedUsersListData"></InvitedUsersTable>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import {getUserInfo, getUserEventOrderList, getUserInviteList} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
import OrderListTable from 'views/communityPurchase/managementOfPurchaseAndPurchase/components/OrderListTable'
import InvitedUsersTable from 'views/communityPurchase/managementOfPurchaseAndPurchase/components/InvitedUsersTable'
export default {
    name: "UserControlInfo",
    data() {
        return {
            activeName: 'first',
            userInfo: {},
            orderListData: {},
            InvitedUsersListData: {},
        }
    },
    mounted() {
        this.findUserInfo()
        this.findOrderList()
        this.findinvitedUserList()
    },
    methods: {
        handleClick(tab, event) {
            // console.log(this.activeName)
            // console.log(tab.name)
        },
        // 查询用户信息
        findUserInfo() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid,
                assinnerid: this.$route.query.assinnerid,
            }
            getUserInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.userInfo = data.data
                    // this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 查询用户详情下订单列表
        findOrderList() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid,
                assinnerid: this.$route.query.assinnerid,
            }
            getUserEventOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 查询用户详情下邀请用户列表
        findinvitedUserList() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid,
                assinnerid: this.$route.query.assinnerid,
            }
            getUserInviteList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.InvitedUsersListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        OrderListTable,
        InvitedUsersTable
    }
}
</script>

<style lang="scss" type="text/scss">
    .userControlInfo{
        .user_info_box{
            margin-bottom: 28px;
            &>div{
                display: flex;
                margin-bottom: 10px;
                &>div{
                    width: 33%;
                    display: flex;
                    align-items: center;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 100%;
                        margin-right: 10px;
                    }
                    label{
                        color: #606266;
                    }
                    span{
                        color: #303133;
                    }
                }
            }
            &>div:nth-of-type(1){
                margin-bottom: 20px;
            }
        }
        .tabs_box{
            .el-tabs__header {
                margin: 0;
            }
            .order_list_box, .invited_users_box{
                margin-top: 30px;
                .el-table th>.cell {
                    font-weight: bold!important;
                    white-space: nowrap;
                    font-size: 16px;
                }
                .el-table__empty-block {
                    min-height: 500px;
                }
            }
        }
    }
</style>